import { createContext, useContext } from 'react';

import type { DepositListContextValues } from './types';

const DepositListContext = createContext<DepositListContextValues | undefined>(
  undefined
);

export const DepositListContextProvider = DepositListContext.Provider;

export const useDepositListContext = () => {
  const values = useContext(DepositListContext);

  if (!values) {
    throw new Error(
      'useDepositListContext must be used within a DepositListContext.Provider'
    );
  }
  return values;
};
